import YTDSnapshot from './YTDSnapshot';

export default YTDSnapshot;
